define('OrderWizard.Module.ShowShipments.Extension', [
  'OrderWizard.Module.ShowShipments',

  'Backbone',
  'SC.Configuration',
  'jQuery',
  'Utils',
  'underscore'
], function (
  OrderWizardModuleShowShipments,

  Backbone,
  Configuration,
  jQuery,
  Utils,
  _
) {
  'use strict';

  _.extend(OrderWizardModuleShowShipments.prototype, {
    getContext: _.wrap(OrderWizardModuleShowShipments.prototype.getContext, function (fn) {
      var context = fn.apply(this, _.toArray(arguments).slice(1));
      var shipMethods = context.shippingMethods;
      var placeholderShippingItem = Configuration.get('customship.placeholderid');

      if (shipMethods.length) {
        var tbd = _.findWhere(shipMethods, { internalid: placeholderShippingItem });
        if(tbd)
        {
          
          tbd.rate_formatted = 'TBD';
        }
      }

      return context;
    })
  });
});
